



import React, {Component} from 'react';
import "./igv-page.css";

import {connect} from "react-redux";
import IGV from "./components/igv-browser/IGV";


function getUrlVars() {
    let vars = {};
    let parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
}

class IGV_Page extends Component {

    constructor(props) {
        super(props);

        this.igv_default = {genome: 'hg38', locus: 'BRCA1'};
        this.state = {
            experimentName: undefined,
            locusFull: "",
            serverAuthorization: false,
            login_details: undefined,
            failed: false
        }
    }
    
    
    
    componentDidMount() {

        let config = window.config;
        let { token } = this.props;
        let self = this;
        let {server_url} = config;

        let experimentName = getUrlVars()['file'];
        let chrom = getUrlVars()['chrom'];
        let locus = getUrlVars()['locus'];
        let locus_full = chrom + ":" + locus;


        this.setState({
            experimentName: experimentName,
            chrom: chrom,
            locus: locus_full
        })


    }


    render(){
       // /browser/?file=E032847&chrom=8&locus=128,747,267-128,754,546
            //"?chrom=8&locus=128,747,267-128,754,546"

        let config = window.config;
        let {server_url} = config;
        let {track_config, source_type} = config;
        let {tracks_configurations} = config;
        let genome_ref = (config.genome_ref) ? config.genome_ref : "hg19"


        let { token } = this.props;
        let { experimentName, locus } = this.state;

        let BAM_URL_2 = server_url + '/reads/' + experimentName;


        let BAM_URL = server_url + '/reads/' + experimentName;
        let BAI_URL = server_url + '/reads/' + experimentName + '.bai';


        let server_options;

        let track = [
            {
                type: 'alignment',
                sourceType: 'htsget',
                url: BAM_URL_2,
                endpoint: server_url,
                id: experimentName,
                name: experimentName,
                oauthToken: token
            }
        ];

        if(source_type === "htsget"){
            server_options = {
                genome: genome_ref,
                locus: locus,
                tracks: track
            };
        }
        else{
            let tracks= [];
            let experiments= experimentName ? experimentName.split(",") : [];
            /*experiments.forEach(experiment_name => {
              // Apply the same logic for each experiment
              let tracksForExperiment = experiment_name ? tracks_configurations.map(track => {
                return {
                  url: server_url + "/getbai/" + experiment_name + track.name,
                  type: track.type,
                  format: track.format,
                  indexURL: track.indexURL !== false ? server_url + "/getbai/" + experiment_name + track.indexURL : false,
                  name: experiment_name + track.name,
                  colorBy: track.colorBy ? track.colorBy : null,
                  oauthToken: token,
                  visibilityWindow: track.visibilityWindow
                };
              }) : [];
              
              // Concatenate tracks for the current experiment to the overall array
              tracks = tracks.concat(tracksForExperiment);
            });*/
            tracks_configurations.forEach(track => {
                // Apply the same logic for each experiment
                let tracksForExperiment = experiments ? experiments.map(experiment_name => {
                  return {
                    url: server_url + "/getbai/" + experiment_name + track.name,
                    type: track.type,
                    format: track.format,
                    indexURL: track.indexURL !== false ? server_url + "/getbai/" + experiment_name + track.indexURL : false,
                    name: experiment_name + track.name,
                    colorBy: track.colorBy ? track.colorBy : null,
                    oauthToken: token,
                    visibilityWindow: track.visibilityWindow
                  };
                }) : [];
                
                // Concatenate tracks for the current experiment to the overall array
                tracks = tracks.concat(tracksForExperiment);
              });
            server_options = {
                genome: genome_ref,
                locus: locus,
                tracks: tracks 
                 
               
            };
        }


        if(this.props.authenticated && this.state.experimentName!== undefined)
        {
            return <React.Fragment>
                <IGV config={server_options} track = {track} chrom={this.state.chrom}/>
            </React.Fragment>
        }
        else if(this.state.experimentName === undefined)
        {
            return <div className={"error_msg"}>
                <div>Please provide an Experiment ID</div>
                <div>E.g.  ...browser/?file=EXPERIMENTID&chrom=18&locus=12650-12670</div>
            </div>
        }

    }
}



function mapStateToProps (state) {
    if(state.authorization!==undefined)
    {
        return {token: state.authorization.token, authenticated:state.authorization }
    }
}

/*const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(Actions, dispatch)
});*/



//export default Login;

export default connect(mapStateToProps)(IGV_Page);
